import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import {
	type ServiceFulfillmentPartnerFormSchema,
	serviceFulfillmentPartnerSchemaForm,
} from "@msuite/utils/schemas";
import { FormProvider, useForm } from "react-hook-form";
import { ServiceFulfillmentPartnerForm } from "@/forms/service-fulfillment-partner-form";
import { client } from "@/hono";

interface AddServiceFulfillmentPartnerModalProps extends ModalProps {
	onComplete?: () => Promise<void>;
	serviceId: string;
}

export function AddServiceFulfillmentPartnerModal({
	isOpen,
	onClose,
	serviceId,
	onComplete,
}: AddServiceFulfillmentPartnerModalProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm({
		resolver: resolver(serviceFulfillmentPartnerSchemaForm),
	});

	/** Functions */
	async function handleOnSubmit(json: ServiceFulfillmentPartnerFormSchema) {
		try {
			await client.organizations.services[":serviceId"].partner.$post({
				param: { serviceId },
				json,
			});
			await onComplete?.();
			methods.reset();
			onClose?.();
		} catch (error) {
			console.error(error);
		}
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<Modal
				isOpen={isOpen}
				onClose={onClose}
				title={t("organization.data.add_fulfillment_partner")}
				onSubmit={methods.handleSubmit(handleOnSubmit)}
				data-cy="add-fulfillment-partner-form"
			>
				<Modal.Body>
					<ServiceFulfillmentPartnerForm />
				</Modal.Body>
				<Modal.FooterForm />
			</Modal>
		</FormProvider>
	);
}
